import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import LoginPage from "./app/containers/Login";
import CreateAccountPage from "./app/containers/CreateAccount";
import ForgotPasswordPage from "./app/containers/ForgotPassword";
import OtpPage from "./app/containers/Otp";
import ResetPasswordPage from "./app/containers/ResetPassword";
import PasswordChangedPage from "./app/containers/PasswordChanged";
import TermsAndConditionsPage from "./app/containers/TermsAndConditions";
import DashboardPage from "./app/containers/Dashboard";
import AppointmentsPage from "./app/containers/Appointments";
import UserDetailPage from "./app/containers/UserDetail";
import AnalyticsPage from "./app/containers/Analytics";
import AdminDashboardPage from "./app/containers/AdminDashboard";
import RequireAuth from "./app/components/RequireAuth";
import RequireAdmin from "./app/components/RequireAdmin";
import RedirectIfAuthed from "./app/components/RedirectIfAuthed";
import NavigationBridge from "./app/components/NavigationBridge";
import { GlobalStyle } from "./app/global-styles";
import { GOOGLE_CLIENT_ID } from "./utils/constants";

export default function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <BrowserRouter>
        <GlobalStyle />
        <NavigationBridge />
        <Routes>
          <Route element={<RedirectIfAuthed />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<CreateAccountPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/verify" element={<OtpPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/password-changed" element={<PasswordChangedPage />} />
          </Route>

          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditionsPage />}
          />

          <Route element={<RequireAuth />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/appointments" element={<AppointmentsPage />} />
            <Route path="/user-detail" element={<UserDetailPage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route element={<RequireAdmin />}>
              <Route path="/admin" element={<AdminDashboardPage />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
}
